const files = require.context('.', false, /\.js$/)
let configRouters = []
files.keys().forEach(key => {
    if (key === './index.js') return
    configRouters = configRouters.concat(files(key).default).sort((a, b)=> a.sort?(a.sort- b.sort) : -1) 
})
export default configRouters
